const TIME_ZONE = process.env.VUE_APP_TIME_ZONE


export default {
    formatDateTime(dateTime: any, ignoreTz = false) {
        const dt = ignoreTz ? dateTime : this.changeTimeZone(dateTime, TIME_ZONE);
        const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);

        return(`${
            padL(dt.getDate())}-${
            padL(dt.getMonth()+1)}-${
                dt.getFullYear()} ${
            padL(dt.getHours())}:${
            padL(dt.getMinutes())}:${
            padL(dt.getSeconds())}`
        );
    },
    changeTimeZone(date = new Date(), timeZone) {
        if (typeof date === 'string') {
            return new Date(
                new Date(date).toLocaleString('en-US', {
                    timeZone,
                }),
            );
        }

        return new Date(
            date.toLocaleString('en-US', {
                timeZone,
            }),
        );
    },
    formatDate(dateTime: any) {
        const dt = this.changeTimeZone(dateTime, TIME_ZONE);
        const padL = (nr, len = 2, chr = `0`) => `${nr}`.padStart(2, chr);

        return `${padL(dt.getDate())}-${padL(dt.getMonth() + 1)}-${dt.getFullYear()}`;
      }
};
